export default "__VITE_ASSET__4097ef7d__"